import React, { useState } from 'react';
import { TbAlertTriangle, TbPencil, TbTrash } from 'react-icons/tb';
import { Box, Col, FabButton, Flex, Icon, Row, Typography, Dialog } from '../../../ppui';
import { getDateProperFormatForInput, getDateProperFormatForInputFn } from '../../../utils/common';
import { AllowanceBox } from '../../style';

const HolidayList = ({ resource, handleEditModalOpen,deleteHoliday }) => {
  if (!resource) {
    throw new Promise(() => { });
  }

  const bankRes = resource.read();
  const currentDate = new Date();

  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedHoliday, setSelectedHoliday] = useState(null);

  const openDeleteModal = (holiday) => {
    setSelectedHoliday(holiday);
    setDeleteModalOpen(true);
  };

  const confirmDelete = () => {
    if (selectedHoliday) {
      deleteHoliday(selectedHoliday.holidayId)
    }
    setDeleteModalOpen(false);
    setSelectedHoliday(null);
  };

  return (
    <>
      {bankRes?.data?.data?.holidays?.length ? (
        <Flex gap={20} direction={"column"}>
          {bankRes?.data?.data?.holidays?.map(it => {
            const holidayDate = new Date(it?.holidayDate);
            const isFutureOrToday = holidayDate >= currentDate;

            return (
              <AllowanceBox key={it?.id}>
                <Row alignItems="center">
                  <Col xs={4}>
                    <Box>
                      <Box className="label">Name</Box>
                      <Box onClick={() => handleEditModalOpen({ ...it, holidayDate: getDateProperFormatForInput(it?.holidayDate) })} className="value">
                        {it?.holidayName}
                      </Box>
                    </Box>
                  </Col>
                  <Col xs={3}>
                    <Box>
                      <Box className="label">Date</Box>
                      <Box className="value">{getDateProperFormatForInputFn(it?.holidayDate) || "-"}</Box>
                    </Box>
                  </Col>
                  <Col xs={3}>
                    <Box>
                      <Box className="label">Day</Box>
                      <Box className="value">{new Intl.DateTimeFormat("en-US", { weekday: "long" }).format(new Date(it?.holidayDate))}</Box>
                    </Box>
                  </Col>
                  <Col xs={2}>
                    <Flex justifyContent="end" gap={10}>
                      <Box>
                        <FabButton
                          size="sm"
                          icon={<TbPencil />}
                          onClick={() => handleEditModalOpen(it)}
                          variant="filled"
                          shape="box"
                        />
                      </Box>
                      {isFutureOrToday && (
                        <Box>
                          <FabButton
                            size="sm"
                            icon={<TbTrash />}
                            onClick={() => openDeleteModal(it)}
                            variant="filled"
                            shape="box"
                          />
                        </Box>
                      )}
                    </Flex>
                  </Col>
                </Row>
              </AllowanceBox>
            );
          })}
        </Flex>
      ) : (
        <AllowanceBox>
          <Icon color={"danger"} size={"lg"}>
            <TbAlertTriangle />
          </Icon>
          <Typography variant="body1" display="flex" gap={10} alignItem="center" mb={"0"} p={15}>
            No predefined holiday available.
          </Typography>
        </AllowanceBox>
      )}

      <Dialog
        open={isDeleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        onSubmit={confirmDelete}
        title="Confirm Deletion"
        action={true}
        buttonName="Delete"
        separator
      >
        <Typography variant="body1" mb={15}>
          Are you sure you want to delete <strong>{selectedHoliday?.holidayName}</strong>?
        </Typography>
      </Dialog>
    </>
  );
};

export default HolidayList;
